module.exports = __webpack_public_path__ + "img/orderHistory.82561789.png";